export function deepMerge(target, source) {
    for (const key in source) {
        const sourceVal = source[key];
        const targetVal = target[key];

        if (Array.isArray(sourceVal) && Array.isArray(targetVal)) {
            for (let i = 0; i < sourceVal.length; i++) {
                if (sourceVal[i] == null) continue; // Skip null/undefined entries. Eg: you want to update only the third column columns: [null, null, {...}

                if (typeof sourceVal[i] === 'object' && targetVal[i]) {
                    deepMerge(targetVal[i], sourceVal[i]);
                } else {
                    targetVal[i] = sourceVal[i];
                }
            }
        } else if (
            sourceVal &&
            typeof sourceVal === 'object' &&
            !Array.isArray(sourceVal)
        ) {
            if (!targetVal || typeof targetVal !== 'object') {
                target[key] = {};
            }
            deepMerge(target[key], sourceVal);
        } else {
            target[key] = sourceVal;
        }
    }
}